import React from "react";
import { inject, observer } from "mobx-react";
import BaseMLBTrackingAccuracyReportContainer from "./BaseMLBTrackingAccuracyReportContainer";
import NonMLBTrackingAccuracyReportTable from "../components/accuracyReports/NonMLBTrackingAccuracyReportTable";
import IncidentTypes from "../constants/IncidentTypes";
import InternationalIndependentGameActionDropDownContainer from "./InternationalIndependentGameActionDropDownContainer";

class InternationalIndependentTrackingAccuracyReportContainer extends React.Component {
  render() {
    const rootStore = this.props.rootStore;
    const description =
      "A real-time pitch-by-pitch data report that monitors the overall quality of data and video systems used for International &Independent games.<br /> <br /> <b>Note: Orange cells denote games with Club system tracking integrated</b>";

    //May need to create a InternationalIndependentTrackingAccruacyRportTable
    const reportTable = (
      <NonMLBTrackingAccuracyReportTable
        data={
          rootStore.InternationalIndependentGameActionStore
            .trackingAccuracyReportSource.data
        }
        gameStatuses={rootStore.veracityStore.gameStatuses}
        canCreateIncident={rootStore.authStore.hasIncidentEdit}
        groupsToShow={rootStore.tableControlsStore.state}
        dropDownContainer={InternationalIndependentGameActionDropDownContainer}
      />
    );
    return (
      <BaseMLBTrackingAccuracyReportContainer
        header="International & Independent Statcast Data & Coaching Video Report"
        description={description}
        reportSource={
          rootStore.InternationalIndependentGameActionStore
            .trackingAccuracyReportSource
        }
        reportTable={reportTable}
        incidentTypesToFetch={[
          IncidentTypes.InternationalIndependent,
          IncidentTypes.SYSTEM,
        ]}
        showSystemIncidentButton={rootStore.authStore.hasIncidentEdit}
      />
    );
  }
}

export default inject("rootStore")(
  observer(InternationalIndependentTrackingAccuracyReportContainer),
);
